/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

export function checkUserRoles(studyGid, userAssignments) {
  const studyAssignments = userAssignments.filter((assignment) => assignment.studyGid === studyGid);
  return studyAssignments.find(
    (assignment) =>
      assignment.canViewPhi &&
      (assignment.userRole.roleName === 'INVESTIGATOR' || assignment.userRole.roleName === 'SITE_USER')
  );
}
